import { gsap } from "gsap"
import { ScrollTrigger } from "gsap/dist/ScrollTrigger"

const gsapProductFeatures = {};

gsapProductFeatures.init = () => {
    gsap.registerPlugin(ScrollTrigger);

    let backgrounds = gsap.utils.toArray(".product-background");
    let textBoxes = gsap.utils.toArray(".product-description");

    // without the if the "snap" effect occurs on other pages too
    if (backgrounds.length > 0 && textBoxes.length > 0) {
        let timeline = gsap.timeline({
            scrollTrigger: {
                trigger: ".product-features__wrapper",
                endTrigger: ".end-product-features",
                start: "top top",
                end: "bottom bottom",
                pin: true,
                pinSpacing: false,
                scrub: 1,
                snap: {
                    snapTo: 1 / (backgrounds.length - 1),
                    duration: 0.5,
                    delay: 0.01, // delay 0 doesn't work properly
                    inertia: false
                },
                onToggle: () => document.body.classList.toggle('no-navbar-animation'), // prevent navbar visibility when scrolling up
                // markers: true
            }
        })
        timeline.to(backgrounds, {
            yPercent: -100 * (backgrounds.length - 1),
            ease: "none", // avoid element not completely scrolled
        }, "0");
        timeline.to(textBoxes, {
            yPercent: -100 * (textBoxes.length - 1),
            ease: "none", // avoid element not completely scrolled
        }, "0");
    }

};

export default gsapProductFeatures;
